// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"c9dda970","72":"e8efff29","219":"884e06d3","246":"4e2110ea","256":"17aeb6a1","280":"3982d82b","427":"0967eed1","488":"1f45f911","512":"bf678f17","584":"6bcf0d39","627":"6be51de6","694":"c25ddcfb","697":"e2eece4c","977":"3ff1b684"}[chunkId] + ".chunk.js";
};